import script from "./PrimeiroAcessoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimeiroAcessoModal.vue?vue&type=script&setup=true&lang=js"

import "./PrimeiroAcessoModal.vue?vue&type=style&index=0&id=10035648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10035648"]])

export default __exports__